import type { IIssueReportLastError } from '../common-types/issue-report';

const QUERY_SEPARATOR = '?';

let lastApiError: IIssueReportLastError | null = null;

// Strips the gateway origin and the query string so the endpoint stays readable
// and no query parameter (which may carry member data) is ever reported.
const getEndpoint = (config: any): string => {
  const method = config?.method ? String(config.method).toUpperCase() : 'GET';
  const url = config?.url ? String(config.url) : '';

  if (!url) {
    return method;
  }

  let path = url;

  if (url.startsWith('http')) {
    try {
      path = new URL(url).pathname;
    } catch (e) {
      path = url.split(QUERY_SEPARATOR)[0];
    }
  } else {
    path = url.split(QUERY_SEPARATOR)[0];
  }

  return `${method} ${path}`;
};

const getMessage = (error: any): string | undefined => {
  const data = error?.response?.data;

  if (typeof data === 'string') {
    return data;
  }

  return data?.message ?? data?.title ?? error?.message;
};

// Called from the axios interceptors so the "Report an issue" payload can carry
// the failure the member actually hit.
export const setLastApiError = (error: any): void => {
  lastApiError = {
    endpoint: getEndpoint(error?.config),
    httpStatus: error?.response?.status ?? null,
    code: error?.response?.data?.code ?? error?.code,
    message: getMessage(error),
    at: new Date().toISOString(),
  };
};

export const getLastApiError = (): IIssueReportLastError | null => lastApiError;

export const clearLastApiError = (): void => {
  lastApiError = null;
};
